import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpBackend, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable()
export class DataService {

	private httpClient: HttpClient;

	constructor( handler: HttpBackend
	) { 
		this.httpClient = new HttpClient(handler);
	}

	getData(): Observable<any> {
		return this.httpClient.get<any>(`${environment.localBackendResource}/data/all`);
	}

	createData(body:any): Observable<any> {
		return this.httpClient.post(`${environment.localBackendResource}/data/create`,body);
	} 
}